import initialState from 'redux/initial-states/dashboard';
import addReferral from './addReferral';
import redeemReferral from './redeemReferral'

export default (state = initialState, action = {}) => ({
  ...state,
  ...addReferral(state, action),
  ...redeemReferral(state, action)
});
